import { AppPageEnum } from "app/shared/enums";
import { ReasonOption } from "app/shared/constants/reconciliation-reasons";

// skipcq: JS-0323
export class ConfirmModel<T1 = any, T2 = any> {
    // skipcq: JS-0323
    container: any;
    message!: string;
    visible = false;
    action!: T1;
    section!: T2;
    includeNote = false;
    includeSubject = false;
    subject = '';
    note = '';
    confirmBtnText = 'Confirm';
    cancelBtnText = 'Cancel';
    bigIcon = true;
    includeFiles = false;
    files: File[] = [];
    includeReasonDropdown = false;
    reasonOptions: ReasonOption[] = [];
    selectedReason = '';
    reasonNote = '';
    // skipcq: JS-0323
    data: any;
    confirmed = false;
    confirmResponseScope = AppPageEnum.Base;

    constructor(init?: Partial<ConfirmModel<T1, T2>>) {
        if (init) {
            this.container = init.container;
            this.message = init.message ?? '';
            this.section = init.section ?? 'DEFAULT' as T2;
            this.visible = init.visible ?? false;
            this.action = init.action ?? 'DEFAULT' as T1;
            this.data = init.data;
            this.confirmed = init.confirmed ?? false;
            this.confirmResponseScope = init.confirmResponseScope ?? AppPageEnum.Base;
            this.includeNote = init.includeNote ?? false;
            this.confirmBtnText = init.confirmBtnText ?? 'Confirm';
            this.cancelBtnText = init.cancelBtnText ?? 'Cancel';
            this.bigIcon = init.bigIcon ?? true;
            this.includeFiles = init.includeFiles ?? false;
            this.includeSubject = init.includeSubject ?? false;
            this.includeReasonDropdown = init.includeReasonDropdown ?? false;
            this.reasonOptions = init.reasonOptions ?? [];
            this.selectedReason = init.selectedReason ?? '';
            this.reasonNote = init.reasonNote ?? '';
        }
    }
}